<div class="flex items-center justify-between mb-8">
    <div>
        <h1 class="text-3xl font-extrabold text-slate-800 tracking-tight">Mis Hijos</h1>
        <p class="text-sm font-medium text-slate-500 mt-1">Supervisa la información y asistencia actual de tus hijos.</p>
    </div>
    <div class="p-3 bg-indigo-50 rounded-2xl text-indigo-600 shadow-sm border border-indigo-100">
        <mat-icon svgIcon="heroicons_outline:users" class="icon-size-6"></mat-icon>
    </div>
</div>

<!-- Loading -->
<ng-container *ngIf="loading">
    <div class="flex flex-col items-center justify-center p-12 bg-white rounded-3xl border border-dashed border-slate-200">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="mt-4 text-sm font-medium text-slate-500">Cargando información estudiantil...</p>
    </div>
</ng-container>

<!-- Empty State -->
<ng-container *ngIf="!loading && childrenList.length === 0">
    <div class="flex flex-col items-center justify-center p-12 bg-white rounded-3xl border border-dashed border-slate-200">
        <div class="w-16 h-16 rounded-full bg-slate-50 flex items-center justify-center mb-4">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle" class="text-slate-400 icon-size-8"></mat-icon>
        </div>
        <h3 class="text-lg font-bold text-slate-700">Sin registros</h3>
        <p class="text-sm text-slate-500 text-center max-w-sm mt-1">
            No hemos encontrado hijos asociados a tu perfil. Comunícate con la administración de la IE si crees que es un error.
        </p>
    </div>
</ng-container>

<!-- Children Grid -->
<div *ngIf="!loading && childrenList.length > 0" class="grid grid-cols-1 lg:grid-cols-2 lg:gap-8 gap-5">
    <div *ngFor="let child of childrenList"
         class="group bg-white rounded-3xl p-6 sm:p-8 flex flex-col shadow-sm border border-slate-100 hover:shadow-md transition-all duration-300 relative overflow-hidden">

        <!-- Decorative background blob -->
        <div class="absolute -right-16 -top-16 w-48 h-48 bg-indigo-50/50 rounded-full blur-3xl group-hover:bg-indigo-100/50 transition-colors pointer-events-none"></div>

        <!-- Card Header -->
        <div class="flex items-start gap-5 mb-6 relative z-10">
            <div class="w-14 h-14 rounded-2xl bg-indigo-600 text-white flex items-center justify-center font-bold text-xl shadow-lg shadow-indigo-600/20 shrink-0">
                {{ child.persona.name.charAt(0) | uppercase }}
            </div>
            <div class="flex-1 min-w-0">
                <h2 class="text-[17px] font-extrabold text-slate-800 leading-tight mb-1 truncate" [title]="child.persona.name">
                    {{ child.persona.name }}
                </h2>
                <div class="flex flex-wrap items-center gap-2">
                    <span class="inline-flex items-center px-2.5 py-1 rounded-md text-[11px] font-bold bg-slate-100 text-slate-600 tracking-wider">
                        <mat-icon svgIcon="heroicons_solid:academic-cap" class="icon-sm mr-1"></mat-icon>
                        {{ child.grado.name }} "{{ child.seccion.name }}"
                    </span>
                    <span class="inline-flex items-center px-2.5 py-1 rounded-md text-[11px] font-bold bg-amber-50 text-amber-700 tracking-wider border border-amber-100/50">
                        {{ child.turno }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Card Body -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-auto border-t border-slate-100 pt-5 relative z-10">
            <div class="flex flex-col">
                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Institución Educativa</span>
                <div class="flex items-start gap-2">
                    <mat-icon svgIcon="heroicons_outline:building-office-2" class="icon-sm text-slate-400 mt-0.5 shrink-0"></mat-icon>
                    <span class="text-xs font-semibold text-slate-700 leading-snug">{{ child.institucion.name }}</span>
                </div>
            </div>

            <div class="flex flex-col sm:pl-4 sm:border-l border-slate-100">
                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 flex justify-between">
                    Asistencia Hoy
                    <span class="text-slate-500">{{ child.asistenciaHoy.fecha | date:'dd/MM' }}</span>
                </span>
                <div class="flex items-center gap-2 mt-0.5">
                    <ng-container [ngSwitch]="child.asistenciaHoy.estadoMarcacionId">
                        <span *ngSwitchCase="1" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-slate-100 text-slate-600">
                            <div class="w-2 h-2 rounded-full bg-slate-400 animate-pulse"></div>
                            NO MARCADO
                        </span>
                        <span *ngSwitchCase="2" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100">
                            <mat-icon svgIcon="heroicons_solid:check-circle" class="icon-sm text-emerald-500"></mat-icon>
                            ASISTIÓ
                        </span>
                        <span *ngSwitchCase="3" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-rose-50 text-rose-700 border border-rose-100">
                            <mat-icon svgIcon="heroicons_solid:x-circle" class="icon-sm text-rose-500"></mat-icon>
                            FALTÓ
                        </span>
                        <span *ngSwitchDefault class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-indigo-50 text-indigo-700 border border-indigo-100">
                            {{ child.asistenciaHoy.estadoMarcacion }}
                        </span>
                    </ng-container>
                </div>
            </div>
        </div>

    </div>
</div>
